module.exports = __webpack_public_path__ + "8dfb2d864bb4a687a7a4ec6f195a5142.pdf";